$(function () {
    const quiz = $('.assessment .quiz');

    if (!quiz.length) return;

    let current = 0,
        items = quiz.find('.quiz-wrap .item');

    const btnPrev = quiz.find('.buttons #btn-prev'),
        progresBar = quiz.find('.progress-bar'),
        counter = progresBar.find('.counter'),
        progress = progresBar.find('.progress-line');

    function updateCounter() {
        const template = counter.data('template');
        if (!template) return;

        const total = items.length,
            text = template.replace('%s', current + 1).replace('%s', total);

        counter.text(text);
    }

    function updateProgress() {
        const percent = ((current + 1) / items.length) * 100;
        progress.css('width', `${percent}%`);
    }

    function updateView() {
        items.removeClass('active').eq(current).addClass('active');

        if (current === 0) {
            btnPrev.hide();
            btnPrev.parent().addClass('single');
        } else {
            btnPrev.show();
            btnPrev.parent().removeClass('single');
        }

        updateProgress();
        updateCounter();
    }

    function showResult() {
        let total = 0;

        items.each(function () {
            const val = $(this).find('input[type="radio"]:checked').data('weight');
            if (val !== undefined) {
                total += parseFloat(val);
            }
        });

        quiz.hide();
        quiz.parents('.assessment').find('.result-block').show();

        const states = quiz.parents('.assessment').find('.result-states .list-group');
        let found = false;

        states.each(function () {
            const from = parseFloat($(this).data('score_from'));
            const to = parseFloat($(this).data('score_to'));

            if (total >= from && total <= to) {
                $(this).addClass('show');
                found = true;

                return false;
            }
        });

        if (!found) {
            console.warn('No matching result for score:', total);
        }
    }

    btnPrev.on('click', function () {
        if (current > 0) {
            const stepsToClear = items.eq(current).add(items.eq(current - 1));
            stepsToClear.find('input[type="radio"]').prop('checked', false);
            current--;
            updateView();
        }
    });

    items.find('input[type="radio"]').on('change', function () {
        if (current < items.length - 1) {
            setTimeout(() => {
                current++;
                updateView();
            }, 200);
        } else {
            showResult();
        }
    });

    updateView();
});